import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("camaroo_token");
    const u = localStorage.getItem("camaroo_user");
    if (token && u) {
      try { setUser(JSON.parse(u)); } catch (_) { /* ignore */ }
      api.get("/auth/me").then((r) => {
        setUser(r.data);
        localStorage.setItem("camaroo_user", JSON.stringify(r.data));
      }).catch(() => {
        localStorage.removeItem("camaroo_token");
        localStorage.removeItem("camaroo_user");
        setUser(null);
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    sessionStorage.removeItem("ceo-command-center-filters");
    localStorage.setItem("camaroo_token", r.data.access_token);
    localStorage.setItem("camaroo_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) { /* ignore */ }
    localStorage.removeItem("camaroo_token");
    localStorage.removeItem("camaroo_user");
    sessionStorage.removeItem("ceo-command-center-filters");
    setUser(null);
    // hard redirect ensures all in-flight queries are aborted and routing guards re-evaluate
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}

const ROLE_RANK = { viewer: 0, manager: 1, analyst: 2, workspace_admin: 3, super_admin: 4 };
export function canAtLeast(user, role) {
  if (!user) return false;
  return (ROLE_RANK[user.role] ?? -1) >= (ROLE_RANK[role] ?? 0);
}


export function isLockedDashboardUser(user) {
  if (!user) return false;

  const assigned = user.assigned_dashboard_id || (user.allowed_dashboard_ids || [])[0];
  const adminRoles = ["super_admin", "workspace_admin", "analyst"];

  if (!assigned) return false;
  if (adminRoles.includes(user.role)) return false;

  if (user.builder_access === false || user.datasource_access === false || user.settings_access === false) {
    return true;
  }

  return String(user.role || "").endsWith("_viewer");
}


export function canUseAskAI(user) {
  if (!user) return false;
  if (Array.isArray(user.screens)) return user.screens.includes("ai");

  const role = String(user.role || "").toLowerCase();
  const defaultAllowedRoles = ["super_admin", "workspace_admin", "analyst"];

  if (defaultAllowedRoles.includes(role)) return true;
  if (user.ai_access === true) return true;

  return false;
}
